import request from '../../utils/request';

/** 查询训练任务列表：训练机按「记录库 ∪ 容器事实」现算，不写入数据库 */
export function fetchRuns() {
  return request.get('/blissrose/training/runs');
}

/** 派发训练任务：预校验在训练机，拒绝原因原样透出 */
export function dispatchRun(body) {
  return request.post('/blissrose/training/runs', body);
}

/** 查询单个训练任务详情；item 字段同列表行 */
export function fetchRunDetail(runName) {
  return request.get(`/blissrose/training/runs/${encodeURIComponent(runName)}`);
}

/** 查询训练日志尾：读容器日志流，不读磁盘日志文件 */
export function fetchRunLog(runName, tail) {
  return request.get(`/blissrose/training/runs/${encodeURIComponent(runName)}/log`, {
    params: tail ? { tail } : {},
  });
}

/** 查询每轮指标（results.csv 全表）；超长只发末段，truncated 标出 */
export function fetchRunMetrics(runName) {
  return request.get(`/blissrose/training/runs/${encodeURIComponent(runName)}/metrics`);
}

/** 查产物清单：训练机目录里的全部文件；删任务后只剩 MinIO 归档，不在此列 */
export function fetchRunArtifacts(runName) {
  return request.get(`/blissrose/training/runs/${encodeURIComponent(runName)}/artifacts`);
}

/** 单个产物的下载直链（浏览器直连，同站 cookie 鉴权） */
export function runArtifactDownloadUrl(runName, path) {
  return `/api/blissrose/training/runs/${encodeURIComponent(runName)}/artifacts/download`
    + `?path=${encodeURIComponent(path)}`;
}

/** 打包下载直链；paths 不给即整份产物 */
export function runArtifactsArchiveUrl(runName, paths = []) {
  const query = paths.map(path => `path=${encodeURIComponent(path)}`).join('&');
  return `/api/blissrose/training/runs/${encodeURIComponent(runName)}/artifacts/archive`
    + (query ? `?${query}` : '');
}

/** 停止训练：发信号即返回，不等容器收尾；容器未退出时状态仍是训练中 */
export function stopRun(runName) {
  return request.post(`/blissrose/training/runs/${encodeURIComponent(runName)}/stop`);
}

/** 删除已结束的 run：容器记录、训练目录、日志、记录库一并删除；运行中的任务由训练机拒绝 */
export function deleteRun(runName) {
  return request.delete(`/blissrose/training/runs/${encodeURIComponent(runName)}`);
}

/** 归档产物到 MinIO（自动归档失败后的手工入口）：默认只补缺，force 整份重传 */
export function pushRun(runName, force) {
  return request.post(`/blissrose/training/runs/${encodeURIComponent(runName)}/push`, {
    force: Boolean(force),
  });
}

/** 查询显卡清单（派发选卡用）；occupied_by 只标平台派的在跑任务 */
export function fetchTrainGpus() {
  return request.get('/blissrose/training/gpus');
}

/** 查询可训练的数据集版本：未下到训练机本地的也在列并标出（ref＝<名>@<版本>） */
export function fetchTrainDatasets() {
  return request.get('/blissrose/training/datasets');
}

/** 把数据集版本下载到训练机本地：立即返回，靠轮询 cache_state 等落地；幂等 */
export function materializeDataset(ref) {
  return request.post(`/blissrose/training/datasets/${encodeURIComponent(ref)}/materialize`);
}

/** 查询可作基础权重的模型（weight_type=base 且 MinIO 有副本）；返回不透明 model_id */
export function fetchTrainModels() {
  return request.get('/blissrose/training/models');
}
